

$(document).ready(function() {
 //  var allVariantIds = [];

 //  $('.select_custom_product').each(function() {
 //    var variantId = $(this).find('input[name="id"]').val();
 //    allVariantIds.push(parseInt(variantId));
 //  });


 //  $.getJSON('/cart.js', function(cart) {
 //    var cartVariantIds = cart.items.map(function(item) {
 //      return item.variant_id;
 //    });

 //    var matchedVariantIds = allVariantIds.filter(function(id) {
 //      return cartVariantIds.includes(id);
 //    });
 // $('.select_custom_product').removeClass('show_datta');
 //    if (matchedVariantIds.length > 0) {
 //      console.log('Matched variant IDs:', matchedVariantIds);

 //      $('.select_custom_product').each(function() {
       
 //        var variantId = parseInt($(this).find('input[name="id"]').val());
 //        if (matchedVariantIds.includes(variantId)) {
 //          $(this).addClass('show_datta');
 //        }
 //      });
 //    } else {
 // $('.select_custom_product').removeClass('show_datta');
 //    }
 //  });
});

// fucntion///
function highlightVariantsInCart() {
    var allVariantIds = [];

  $('.select_custom_product').each(function() {
    var variantId = $(this).find('input[name="id"]').val();
    allVariantIds.push(parseInt(variantId));
  });


  $.getJSON('/cart.js', function(cart) {
    var cartVariantIds = cart.items.map(function(item) {
      return item.variant_id;
    });

    var matchedVariantIds = allVariantIds.filter(function(id) {
      return cartVariantIds.includes(id);
    });
 $('.select_custom_product').removeClass('show_datta');
    if (matchedVariantIds.length > 0) {
      console.log('Matched variant IDs:', matchedVariantIds);

      $('.select_custom_product').each(function() {
       
        var variantId = parseInt($(this).find('input[name="id"]').val());
        if (matchedVariantIds.includes(variantId)) {
          $(this).addClass('show_datta');
        }
      });
    } else {
 $('.select_custom_product').removeClass('show_datta');
    }
  });
}








// endfucntion//

$(document).ready(function() {
  highlightVariantsInCart();
});

        $(document).ready(function() {
        $('.plan').click(function() {
                $('.plan').removeClass('selected');
                $('.radio-img').attr('src', 'https://cdn.shopify.com/s/files/1/0559/2750/4983/files/Frame_2121451015_1.png?v=1744246823');
                $(this).addClass('selected');
                $(this).find('.radio-img').attr('src', 'https://cdn.shopify.com/s/files/1/0559/2750/4983/files/Frame_2121451015.png?v=1744246824');
 var inputValue = $('.sellin_plan input[name="selling_plan"]').val();
  
   var plan_value =  $(this).attr('data-plan');
                if (plan_value === 'subscription'){
$('form#custom-form input[name="selling_plan"]').val(inputValue);
                }else if( (plan_value === 'one-time')){
$('form#custom-form input[name="selling_plan"]').val('');

                    
                }
            });

        });


$(document).ready(function() {
    
    $('#add-to-cart-btnaaa').on('click', function(e) {
      e.preventDefault();
      var $form = $(this).closest('.custom_button_wrapper').find('#custom-form');
      var ajaxCartInstance = new window.AjaxCart($form);
      $form.trigger('submit');


    });
  });



$(document).ready(function() {
$(".desc_wrapper .read_more").on("click", function() {
  $('.desc1').fadeOut(200, function() {
    $('.desc2').fadeIn(200);
  });
});

$(".desc_wrapper .read_less").on("click", function() {
  $('.desc2').fadeOut(200, function() {
    $('.desc1').fadeIn(200);
  });
});
});



$(document).ready(function() {
  $('.select_custom_product .svg_btn.plus').on('click', function(e) {
    e.preventDefault();
    
    // Find the closest wrapper, then the form inside it
    var $wrapper = $(this).closest('.sbg_wrapper_selected');
    var $form = $wrapper.find('form');

    // // If using AjaxCart
    // if (typeof window.AjaxCart !== 'undefined') {
    //   var ajaxCartInstance = new window.AjaxCart($form);
    // }

    // $form.trigger('submit');


  var formData = $form.serialize();

  // Add to cart using Shopify AJAX API
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    success: function(item) {
      console.log('Added to cart:', item);

      // Redirect directly to checkout
      window.location.href = '/checkout';
    },
    error: function(xhr, status, error) {
      console.error('Error adding to cart:', error);
      alert('Sorry, something went wrong adding to cart.');
    }
  });



// check cart////
setTimeout(function() {

  highlightVariantsInCart();

            },2000);
  });
});




$(document).on('click', '.select_custom_product.show_datta svg.svg_btn.minus', function() {

    var data_all = $(this).closest('.sbg_wrapper_selected').find('input[name="id"]').val();
  console.log('data_all', data_all);
$('.js-mini-cart-content .mini-cart-item[var_id="'+data_all+'"] button.btn.js-remove-mini-cart').click();
$('.js-mini-cart-content button.btn.js-remove-mini-cart[data-id="'+data_all+'"]').click();
  
    setTimeout(function() {
  highlightVariantsInCart();
            },3000);
});








$(document).on('click', '.js-mini-cart-content button.btn.js-remove-mini-cart', function() {
    
     setTimeout(function() {
  highlightVariantsInCart();
            },3000);
});




$(document).ready(function() {
    $('.new_banner_section .page-width.wrapper .banner_content .banner_btn, .custom_banner_section .page-width.wrapper .banner_content .banner_btn, section.custom_time_counter .wrapper .btn_heading_wrap .banner_btn').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.custom_featured_product').offset().top
        }, 800);
    });
});

$(document).ready(function() {
    $('.custom_featured_product .custom_reviews, section.custom_new_testimonial .wrapper .testimonial_image img, .custom_new_testimonial .testimonial_block .right_block .star, .custom_banner_section .page-width.wrapper .banner_content .page_full_content, .new_custom_review_section .review_wrapper').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.new_custom_review_section').offset().top
        }, 800);
    });
});



document.addEventListener("DOMContentLoaded", function() {
  var thumbSwiper = new Swiper(".custom_featured_product .thumbSwiper", {
    spaceBetween: 19,
    slidesPerView: 6,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".custom_featured_product .thumbSwiper .swiper-button-next",
      prevEl: ".custom_featured_product .thumbSwiper .swiper-button-prev",
    },
    breakpoints: {
      769: { 
        direction: "horizontal",
      },
      481: { 
        direction: "horizontal",
      },
0: { 
          slidesPerView: 4,
      }
    }
  });

  var featuredSwiper = new Swiper(".custom_featured_product .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
    navigation: {
      nextEl: ".custom_featured_product .featuredSwiper .swiper-button-next",
      prevEl: ".custom_featured_product .featuredSwiper .swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
});
$(document).ready(function () {
  var swiper = new Swiper(".custom_video_container .swiper-container", {
    slidesPerView: 4.5,
    spaceBetween: 10,
    loop: false,


    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    breakpoints: {
      0: {
        slidesPerView: 2.5,
      },
      481: {
        slidesPerView: 4.5,
      },
    },
  });
});

$(document).ready(function () {
    $(".custom_video_wrapper .video_container video").click(function () {
        var video = $(this)[0]; // Get the clicked video element
        var playIcon = $(this).siblings(".play_icon_icon"); // Get the play icon inside the same container

        if (video.paused) {
            // Pause all other videos
            $(".custom_video_wrapper .video_container video").each(function () {
                if (this !== video) {
                    this.pause();
                    $(this).siblings(".play_icon_icon").css("opacity", "1");
                }
            });

            // Play clicked video & hide play icon
            video.play();
            playIcon.css("opacity", "0");
        } else {
            // Pause the video & show play icon
            video.pause();
            playIcon.css("opacity", "1");
        }
    });
});






